import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// PD-0001 - Predict Analytics (Fase 5). Endpoints so-admin do tenant; periodo opcional dd/MM/yyyy.

export const getAnalyticsMetricas = async (
  cancel: any,
  dataInicio: string,
  dataFim: string,
  vendedorId?: number | null
): Promise<GetAnalyticsMetricasType | { message: string }> => {
  try {
    const result = await apiService.get('app/predict-analytics/metricas', {
      cancelToken: cancel.token,
      params: { dataInicio, dataFim, ...(vendedorId ? { vendedorId } : {}) },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getAnalyticsVendedores = async (
  cancel: any,
  dataInicio: string,
  dataFim: string,
  page: number,
  vendedorId?: number | null
): Promise<GetAnalyticsVendedoresType | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/predict-analytics/ranking/vendedores',
      {
        cancelToken: cancel.token,
        // Sem sort: a ordenacao e fixa na API (a API descarta o sort).
        params: {
          dataInicio,
          dataFim,
          page: page - 1,
          size: 10,
          ...(vendedorId ? { vendedorId } : {}),
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getAnalyticsClientesPerdidos = async (
  cancel: any,
  dataInicio: string,
  dataFim: string,
  page: number,
  vendedorId?: number | null
): Promise<GetAnalyticsClientesPerdidosType | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/predict-analytics/ranking/clientes-perdidos',
      {
        cancelToken: cancel.token,
        params: {
          dataInicio,
          dataFim,
          page: page - 1,
          size: 10,
          ...(vendedorId ? { vendedorId } : {}),
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// PD-0006 - drill-down. Recebe o MESMO período e o MESMO vendedor aplicados no painel: é
// isso que faz `totalConjunto` bater com o número do card. `busca` filtra a exibição, nunca
// o conjunto. `sort` aceita só as propriedades da whitelist da API (outra devolve 400).
export const getAnalyticsEpisodios = async (
  cancel: any,
  conjunto: ConjuntoAnalyticsType,
  dataInicio: string,
  dataFim: string,
  page: number,
  vendedorId?: number | null,
  busca?: string,
  sort?: string
): Promise<GetAnalyticsEpisodiosType | { message: string }> => {
  try {
    const result = await apiService.get('app/predict-analytics/episodios', {
      cancelToken: cancel.token,
      params: {
        conjunto,
        dataInicio,
        dataFim,
        page: page - 1,
        size: 20,
        ...(vendedorId ? { vendedorId } : {}),
        ...(busca ? { busca } : {}),
        ...(sort ? { sort } : {}),
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}

// Numa resposta `responseType: 'blob'` o CORPO DO ERRO também chega como Blob, então o
// catchError genérico devolveria "Algo de errado aconteceu!" e engoliria justamente a
// orientação que importa (ex.: exportação acima do limite, com instrução de reduzir o
// período). Aqui o blob é lido como texto e a mensagem do usuário é recuperada.
const mensagemDeErroEmBlob = async (error: any): Promise<string> => {
  const corpo = error?.response?.data
  const generico = catchError(error).message
  if (!(corpo instanceof Blob)) {
    return generico
  }
  try {
    const texto = await corpo.text()
    const json = JSON.parse(texto)
    const erro = Array.isArray(json) ? json[0] : json
    return erro?.msgUsuario || generico
  } catch {
    return generico
  }
}

// Exportação do conjunto INTEIRO (sem busca e sem paginação): é o caminho que fecha uma
// auditoria, já que a tela pagina. Vem como blob via axios — `window.open` perderia os
// headers Authorization/X-TENANT-ID e o download voltaria 401.
export const getAnalyticsEpisodiosExport = async (
  conjunto: ConjuntoAnalyticsType,
  dataInicio: string,
  dataFim: string,
  vendedorId?: number | null
): Promise<Blob | { message: string }> => {
  try {
    const result = await apiService.get(
      'app/predict-analytics/episodios/export',
      {
        responseType: 'blob',
        params: {
          conjunto,
          dataInicio,
          dataFim,
          ...(vendedorId ? { vendedorId } : {}),
        },
      }
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return { message: await mensagemDeErroEmBlob(error) }
  }
  return { message: 'Algo de errado aconteceu!' }
}

export const getAnalyticsEvolucao = async (
  cancel: any,
  dataInicio: string,
  dataFim: string,
  vendedorId?: number | null
): Promise<AnalyticsEvolucaoItemType[] | { message: string }> => {
  try {
    const result = await apiService.get('app/predict-analytics/evolucao', {
      cancelToken: cancel.token,
      params: { dataInicio, dataFim, ...(vendedorId ? { vendedorId } : {}) },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return { message: 'Algo de errado aconteceu!' }
}
